<div class="backdrop" *ngIf="isOpen" (click)="closePopup()"></div>

<div class="container popup"  *ngIf="isOpen">
    <header>
      <h1>{{ eventName }}</h1>
    </header>
    <main style="display: contents;">
      <div class="success-icon">
        <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" width="72" height="72" rx="36" fill="#28DE2E" fill-opacity="0.2" />
          <rect x="1" y="0.5" width="71" height="71" rx="35.5" stroke="#007204" stroke-opacity="0.07" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M52.5991 25.5698C53.5291 26.3918 53.6161 27.8138 52.7941 28.7498L35.5441 48.2498C35.3449 48.475 35.1025 48.658 34.8314 48.788C34.5602 48.918 34.2658 48.9924 33.9654 49.0066C33.665 49.0209 33.3649 48.9748 33.0826 48.8711C32.8004 48.7674 32.5418 48.6081 32.3221 48.4028L21.0721 37.9028C20.6393 37.4949 20.3856 36.9323 20.3664 36.3379C20.3472 35.7435 20.5641 35.1657 20.9697 34.7308C21.3753 34.2959 21.9366 34.0392 22.5308 34.0169C23.1251 33.9946 23.7041 34.2085 24.1411 34.6118L33.7111 43.5218L49.4311 25.7618C49.6271 25.54 49.8649 25.3592 50.1309 25.2295C50.3969 25.0998 50.6859 25.0239 50.9813 25.006C51.2767 24.9882 51.5727 25.0288 51.8523 25.1256C52.132 25.2223 52.3899 25.3732 52.6111 25.5698H52.5991Z"
            fill="#0B8F10" />
        </svg>
      </div>
      <h2>Your selfie has been updated!</h2>
      <p>We will notify you when your photos are available.</p>
      <button mat-button (click)="closePopup()" class="close-btn">Close</button>
    </main>
  </div>
  